import { getAvailablePeripheries } from 'helpers/web_to_client'

export const AVAILABLE_PERIPHERIES_REQUEST_START = 'available_peripheries/REQUEST_START'
export const AVAILABLE_PERIPHERIES_REQUEST_SUCCESS = 'available_peripheries/REQUEST_SUCCESS'
export const AVAILABLE_PERIPHERIES_REQUEST_ERROR = 'available_peripheries/REQUEST_ERROR'

export function availablePeripheriesRequestStart() {
    return {
        type: AVAILABLE_PERIPHERIES_REQUEST_START,
    }
}

export function availablePeripheriesRequestError() {
    return {
        type: AVAILABLE_PERIPHERIES_REQUEST_ERROR,
    }
}

export function availablePeripheriesRequestSuccess(data) {
    return {
        type: AVAILABLE_PERIPHERIES_REQUEST_SUCCESS,
        payload: data,
    }
}

export function requestAvailablePeripheries() {
    return async (dispatch, getState) => {
        const { availablePeripheries } = getState()
        if (availablePeripheries.isLoading) return
        dispatch(availablePeripheriesRequestStart())
        try {
            const data = await getAvailablePeripheries()
            dispatch(availablePeripheriesRequestSuccess(data))
        } catch (error) {
            dispatch(availablePeripheriesRequestError())
        }
    }
}



// WEBPACK FOOTER //
// ./state/actions/available_peripheries.js